export interface ItemCardStyle {
  cornerRadius?: number | null;
  borderWidth?: number | null;
  padding?: number | null;
}

export function buildItemCardCssRules(
  s: string,
  style: ItemCardStyle | null | undefined,
): string[] {
  if (!style) return [];

  const props: string[] = [];
  if (typeof style.cornerRadius === "number") {
    props.push(`border-radius: ${style.cornerRadius}px;`);
  }
  if (typeof style.borderWidth === "number") {
    props.push(`border-width: ${style.borderWidth}px;`);
  }
  if (typeof style.padding === "number") {
    props.push(`padding: ${style.padding}px;`);
  }

  if (props.length === 0) return [];

  const rules = [`${s}[data-ui="item-card"] { ${props.join(" ")} }`];

  // Radio option containers (e.g. multiple-choice step) reuse the selection-
  // card style. Needs `!important` to beat the radio's bordered-variant CSS
  // module defaults.
  const importantProps = props.map((p) => p.replace(/;$/, " !important;"));
  rules.push(`${s}[data-ui="option"] { ${importantProps.join(" ")} }`);

  return rules;
}
